export const websiteConfig = {
  pathPrefix: '/',
  description:
    'Create, personalize, and deliver science-informed workouts across app, web, API, and branded member apps. Hyperhuman is fitness content infrastructure: your product, our movement layer.',
  url: 'https://hyperhuman.cc',
  logo: '/logos/logo-1024.png',
  ogLanguage: 'en_US',

  author: 'Hyperhuman',

  twitter: '@hyperhumancc',
  facebook: 'hyperhumancc',

  defaultMetaTitle: 'Personalized Fitness Content Infrastructure | Hyperhuman',
  defaultMetaDescription:
    'Create, personalize, and deliver science-informed workouts across app, web, API, and branded member apps. Your product. Our infrastructure.',
  defaultMetaImage: 'https://images.prismic.io/hyperhuman/Z-gcWXdAxsiBwFTC_hyperhuman-logo-seo.jpg',
  schemaKeywords:
    'fitness content infrastructure, personalized fitness platform, fitness content api, workout api, exercise api, white-label fitness app, branded fitness app, adaptive workout programs, ai workout generator api, ai program builder, fitness app retention, member engagement fitness platform, wellness app infrastructure, science-informed workout programming, physio exercise api, digital physiotherapy platform, patient exercise app, workout personalization api, health-data workout adaptation, white-label vs api fitness',

  schemaIdOrganization: 'https://hyperhuman.cc/#Organization',
  schemaIdSoftware: 'https://hyperhuman.cc/#software',
  schemaIdWebsite: 'https://hyperhuman.cc/#website',
  schemaIdWebpage: 'https://hyperhuman.cc/#webpage',
};

/**
 * Returns the public site URL (env override for build/deploy, else config).
 * Use for canonical URLs, schema URLs, sitemap, and feature/FAQ link building.
 */
export const getSiteUrl = (): string =>
  (typeof process !== 'undefined' && process.env?.GATSBY_URL) || websiteConfig.url;
